import { createContext, useContext } from 'react';

import { type TopLevlNavItem } from '@/layouts/UserProfileLayout/types';
import { type CustomStatusesApi } from '@/tsClient/customStatuses/getCustomStatuses';
import { type CreatorApi } from '@/tsClient/getCreator';
import { type NoodleCustomerApi } from '@/tsClient/getNoodleCustomer';
import { type ProfileApi } from '@/tsClient/my/getProfile';
import { type UserProfileTabsApi } from '@/tsClient/my/getUserProfileTabs';
import { type OrganizationApi } from '@/tsClient/organizations/getOrganization';

type PopulatedUserProfileContextValue = {
  customStatuses: CustomStatusesApi['response'];
  profile: ProfileApi['response'];
  creator: CreatorApi['response'];
  customer: NoodleCustomerApi['response'];
  organization: OrganizationApi['response'];
  profileTabs: UserProfileTabsApi['response'];
};

type UserProfileContextValue = Partial<PopulatedUserProfileContextValue> & {
  browserTabTitle: string | null;
  setBrowserTabTitle: (title: string | null) => void;
  isInUserProfile: boolean;
  currentTab: TopLevlNavItem;
  creatorSlug: string;
  creatorId: string | null;
};

const UserProfileContext = createContext<UserProfileContextValue>({
  browserTabTitle: null,
  creatorId: null,
  creatorSlug: '',
  currentTab: 'home' as const,
  isInUserProfile: false,
  setBrowserTabTitle: () => {
    /* empty */
  },
});

const useUserProfile = (): UserProfileContextValue => useContext(UserProfileContext);

export default UserProfileContext;

export { useUserProfile };

export type { UserProfileContextValue };
